<template>
  <div class="ai-mentor-wrapper">
    <!-- 简历选择 -->
    <div class="head-box">
      <div class="top">
        <img class="icon" src="~@/assets/image/robot_normal.png" />
        <div class="name">快来挑战满分简历吧💯</div>
      </div>
      <div class="content">
        <div class="label">当前辅导简历</div>
        <el-select :value="cvName" disabled>
          <el-option :label="cvName" :value="cvName"></el-option>
        </el-select>
      </div>
    </div>
    
    <!-- 内容 -->
    <div class="ai-mentor-content" v-if="!userHistoryUsed">
      <div class="head-title">
        <span class="iconfont iconaidaoshi"></span>
        <span class="title" v-if="aiStep === 'complete'">解析完成</span>
        <span class="title" v-else>请填写求职信息</span>
      </div>

      <!-- 求职信息填写 -->
      <div class="job-information" v-if="aiStep === 'form'">
        <div class="form-title">求职意向</div>
        <el-form ref="jobInformationForm" :model="jobInformation" :rules="jobInformationRules">
          <div class="intention-form">
            <div class="form-items">
              <div class="form-item">
                <div class="label">求职身份</div>
                <el-form-item prop="job_search_status">
                  <el-select
                    v-model="jobInformation.job_search_status"
                    placeholder="请选择求职身份"
                    popper-class="ai-mentor-select-popper"
                  >
                    <el-option
                      v-for="(item) in jobStatusOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="form-item">
                <div class="label">最高学历</div>
                <el-form-item prop="highestEdu">
                  <el-select
                    v-model="jobInformation.highestEdu"
                    placeholder="请选择最高学历"
                    popper-class="ai-mentor-select-popper"
                  >
                    <el-option
                      v-for="(item) in highestEduOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="form-items">
              <div class="form-item">
                <div class="label">目标行业</div>
                <el-form-item prop="industry">
                  <el-select
                    v-model="jobInformation.industry"
                    placeholder="请选择目标行业"
                    popper-class="ai-mentor-select-popper"
                  >
                    <el-option
                      v-for="(item) in industryOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="form-item">
                <div class="label">是否转行</div>
                <el-form-item prop="changeCareer">
                  <el-select
                    v-model="jobInformation.changeCareer"
                    placeholder="请选择是否转行"
                    popper-class="ai-mentor-select-popper"
                  >
                    <el-option
                      v-for="(item) in changeCareerOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="form-items">
              <div class="form-item">
                <div class="label">职位名称</div>
                <el-form-item prop="jobType">
                  <el-input
                    placeholder="请输入目标职位名称，例如：产品运营"
                    v-model="jobInformation.jobType"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form-item">
              <div class="label">职位描述</div>
              <el-form-item prop="jd">
                <el-input
                  type="textarea"
                  placeholder='可粘贴招聘平台的职位描述
例如："岗位职责：负责AI产品全生命周期管理... 任职要求：5年以上相关经验，熟悉Python和TensorFlow框架... '
                  v-model="jobInformation.jd"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-title">其他关注问题</div>
          <div class="intention-form question">
            
            <div class="form-item">
              <el-form-item prop="user_concerns">
                <el-input
                  type="textarea"
                  placeholder="请填写您最关注的求职分析维度
例如：
如何突出简历中的电商运营项目经验？
我的JAVA技能与岗位要求匹配度如何？
跨行业求职需要补充哪些技能证书？
期望薪资谈判有哪些策略建议？"
                  v-model="jobInformation.user_concerns"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <div class="form-buttons">
          <CompleteButton
            text="提交"
            @clickBtn="submitJobInformation"
          />
        </div>
      </div>

      <!-- 解析中 / 解析异常 -->
      <div class="ai-parsing" v-if="aiStep === 'parsing' || aiStep === 'parsingException'">
        <div class="job-card">
          <div class="job-name">{{jobInformation.jobType || ''}}</div>
          <div class="job-status">{{jobInformation.job_search_status || ''}}</div>
        </div>
        <!-- 解析中 -->
        <div class="ai-loading" v-if="aiStep === 'parsing'">
          <AiGroove :height="45" />
        </div>
        <!-- 解析异常 -->
        <template v-else>
          <div class="head-title" style="margin-top: 36px;">
            <span class="iconfont iconaidaoshi"></span>
            <span class="title">解析完成</span>
          </div>
          <div class="jd-form">
            <div class="question-list">
              <div class="item" v-for="(item, index) in missingQuestionList" :key="index">
                {{ item.suggestion }}
              </div>
            </div>
            <div class="question">
              <el-input
                type="textarea"
                placeholder="请填写补充信息"
                v-model="supplementary_info"
              ></el-input>
            </div>
            <div class="form-buttons">
              <CompleteButton
                text="跳过"
                type="cancel"
                @clickBtn="parseResume"
              />
              <CompleteButton
                text="再次提交"
                @clickBtn="submitJobInformation(true)"
              />
            </div>
          </div>
        </template>
      </div>

      <!-- 开始评估完成 -->
      <div class="ai-parse-resume" v-if="aiStep === 'parseResume'">
        <div class="job-card">
          <div class="job-name">{{jobInformation.jobType || ''}}</div>
          <div class="job-status">{{jobInformation.job_search_status || ''}}</div>
        </div>
        <div class="results-content">
          <div class="results-head">
            <div class="time-info">
              <div class="label">深度思考</div>
              <div class="time">{{ formatTime }}</div>
            </div>
            <div class="ai-loading"><AiGroove :height="45" /></div>
          </div>

          <div class="results-box">
            <!-- 分析进度 -->
            <div class="think-step">
              <template v-for="(item, index) in aiThinkStepOptions">
                <div class="step" :key="index" v-if="aiThinkStep >= index">
                  <div class="iconfont iconxuanzhong" v-if="aiThinkStep > index"></div>
                  <div class="iconfont loading" v-else></div>
                  <div class="label">{{item}}</div>
                </div>
              </template>
            </div>
            <!-- 分析结果 -->
            <div class="content" id="aiMentorContent">
              <!-- 开始思考 -->
              <!-- <div class="item-content" v-html="aiThinkStep0Content"></div> -->

               <!-- 简历评估 -->
              <div class="ai-think-title" v-if="aiThinkStep1Content" style="margin-top:0">简历评估</div>
              <div class="item-content" v-html="formatMarkedHtml(aiThinkStep1Content)"></div>

              <!-- 职位评估 -->
              <div class="ai-think-title" v-if="aiThinkStep2Content">职位评估</div>
              <div class="item-content" v-html="formatMarkedHtml(aiThinkStep2Content)"></div>

              <!-- 简历优化 -->
              <!-- <div class="ai-think-title" v-if="aiThinkStep3Content">简历优化</div>
              <div class="item-content" v-html="formatMarkedHtml(aiThinkStep3Content)"></div> -->

              <!-- 报告生成 -->
              <!-- <div class="ai-think-title" v-if="aiThinkStep4Content">报告生成</div>
              <div class="item-content" v-html="formatMarkedHtml(aiThinkStep4Content)"></div> -->

              <!-- 用户鼓励 -->
              <div class="ai-think-title" v-if="aiThinkStep5Content"></div>
              <div class="item-content" v-html="formatMarkedHtml(aiThinkStep5Content)"></div>
            </div>
          </div>
          <div class="form-buttons" v-if="aiThinkStep > 5 ">
            <CompleteButton
              @click="viewReport()"
              text="查看报告"
            />
          </div>
        </div>

      </div>

    </div>

    <!-- 如果用户历史是使用过，那就走 -->
    <div class="ai-mentor-report" v-else>
      <div class="form-buttons">
        <CompleteButton
          @click="viewReport()"
          text="查看报告"
        />
      </div>
    </div>
    
    <!-- 没有次数提示 -->
    <NoCountModal v-if="showNoCountModal"
      @nextAction="noCountNextAction"
      @knowAction="noCountKnowAction"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import api from '@/api';
import { marked } from 'marked';
import { debounce } from '@/assets/js/util';

// components
import AiGroove from '@/components/base/aiGroove.vue';
import CompleteButton from '../CompleteButton/CompleteButton.vue';
import NoCountModal from './NoCountModal.vue';

const jobStatusOptions = ['找实习','找校招','1-3年工作经验','4-7年工作经验','7年以上工作经验']
const highestEduOptions = ['本科及以下','硕士及以上']
const industryOptions = ['央国企（含银行）','IT/互联网','咨询/金融/四大/商业分析','广告/传媒','快消/贸易','教育/培训','房地产/建筑','其他']
const changeCareerOptions = ['是','否']
const aiThinkStepOptions = ['开始思考','简历评估','职位评估','简历优化', '报告生成', '用户鼓励']

export default {
  name: 'AiMentor',
  props: {
    cvDetail: {
      type: Object,
      default: () => ({}),
    },
    profile: {
      type: Object,
      default: () => ({}),
    },
    cvName: {
      type: String,
      default: '',
    },
  },
  components: {
    CompleteButton,
    AiGroove,
    NoCountModal
  },
  data() {
    return {
      jobStatusOptions,
      highestEduOptions,
      industryOptions,
      changeCareerOptions,
      aiMentorCheckCount: 0, // 简历评估次数

      // 职位信息表单
      jobInformation:{
        jobType: '',
        job_search_status: '',
        highestEdu: '',
        industry: '',
        changeCareer: '',

        jd: ``,
        user_concerns: '',
      },
      jobInformationRules: {
        jobType: [
          { required: true, message: '请填写职位名称', trigger: 'blur' },
        ],
        job_search_status: [
          { required: true, message: '请选择求职身份', trigger: 'change' },
        ],
        highestEdu: [
          { required: true, message: '请选择最高学历', trigger: 'change' },
        ],
        industry: [
          { required: true, message: '请选择目标行业', trigger: 'change' },
        ],
        changeCareer: [
          { required: true, message: '请选择是否转行', trigger: 'change' },
        ],
        jd: [
          { required: true, message: '请填写职位描述', trigger: 'blur' },
        ],
        user_concerns: [
          { required: true, message: '请填写你的关注问题', trigger: 'blur' },
        ],
      },
      formSubmitLoading: false,
      aiStep: 'form', //提交信息form，解析中parsing，解析异常parsingException，评估开始parseResume
      missingQuestionList: [], //解析问题列表
      supplementary_info: '', //用户补充的问题

      // 进入解析阶段
      aiThinkStep: 0, //思考阶段
      thinkTime: 0, //思考时间
      thinkTimer: null, //定时器
      aiThinkStepOptions,
      aiThinkStep1Content: '', // 简历评估
      aiThinkStep2Content: '', // 职位评估
      // aiThinkStep3Content: '', // 简历优化
      // aiThinkStep4Content: '', // 报告生成
      aiThinkStep5Content: '', // 用户鼓励

      userHistoryUsed: false, // 是否使用过历史数据

      showNoCountModal: false, //是否提示无次数了
      
      // 存储取消连接的函数
      cancelCvAssessmentConnection: null,
      cancelJobAssessmentConnection: null,
      
    };
  },
  computed: {
    formatTime() {
      let time = this.thinkTime
      if(time <= 60){
        return `${time}s`
      }else if(time <= 3600){
        let minute = Math.floor(time / 60)
        let second = time - minute * 60
        return `${minute}m${second}s`
      }else{
        let hour = Math.floor(time / 3600)
        let minute = Math.floor((time - hour * 3600) / 60)
        let second = time - hour * 3600 - minute * 60
        return `${hour}h${minute}m${second}s`
      }
    },
    cv_token(){
      return this.cvDetail?.basic_info?.token || ''
    },
  },
  created() {
    // this.initAiFormData()
  },
  beforeDestroy() {
    // 组件销毁前取消所有流连接
    if (this.cancelCvAssessmentConnection) {
      this.cancelCvAssessmentConnection();
    }
    if (this.cancelJobAssessmentConnection) {
      this.cancelJobAssessmentConnection();
    }
    // 清理定时器
    if (this.thinkTimer) {
      clearInterval(this.thinkTimer);
    }
  },
  watch: {
    cvDetail: {
      handler (newVal) {
        if(newVal && newVal?.basic_info?.token){
          //有简历token，读取本地信息
          this.initAiFormData()
        }
      },
      deep: true,
    }
  },
  methods: {
    ...mapActions('editor', ['getFormatCvInfo']),
    formValidate () {
      let flag = false
      this.$refs['jobInformationForm'].validate(valid => {
        flag = valid
      })
      return flag
    },
    formatMarkedHtml (html) {
      // // 处理markdown语法
      // let result = marked(html)
      // // 处理换行
      // result = result.replace(/<br\s*\/?>/g, '\n')
      // return result
      let result = html.replace(/\`\`\`markdown/g, '')
      result = result.replace(/\`\`\`/g, '')
      
      return marked(result)
    },
    // 初始化表单数据，读取本地数据
    initAiFormData: debounce(function() {
      let aiMentorKey = `${this.cvDetail?.basic_info?.token}_aiMentor`
      let aiMentorData = localStorage.getItem(aiMentorKey)
      if(aiMentorData){
        aiMentorData = JSON.parse(aiMentorData)
        // aiMentorData jobInformation, aiStep, thinkTime, aiThinkStep1Content, aiThinkStep2Content
        // 处理表单数据
        if(aiMentorData?.jobInformation){
          this.jobInformation = {
            ...this.jobInformation,
            ...aiMentorData?.jobInformation
          }
        }
        // 标记解析阶段已结束
        if(aiMentorData?.aiStep && aiMentorData?.aiStep == 'parseResume'){
          this.aiStep = 'parseResume'
          this.thinkTime = aiMentorData?.thinkTime
          this.aiThinkStep1Content = aiMentorData?.aiThinkStep1Content
          this.aiThinkStep2Content = aiMentorData?.aiThinkStep2Content
          // 直接走完
          this.getAiThink5Content(true)
        }else{
          // 通过获取报告详情来判断以前是否有过
          this.getAiMentorReport()
        }
      }else{
        // 通过获取报告详情来判断以前是否有过
        this.getAiMentorReport()
      }
    }, 300),

    // 获取报告详情
    getAiMentorReport(){
      let cv_token = this.cvDetail?.basic_info?.token
      if(!cv_token){
        return
      }
      api.AI.getAiMentorReport({
        cv_token: cv_token
      }).then(res => {
        if (res.code == 1000 && res.data.report_generation) {
          // this.userHistoryUsed = true
        }
      }).catch(err => {
        console.log(err);
      });
    },
    // 提交职位信息
    async submitJobInformation(submitAgain){
      // 检测表单完整性
      let flag = submitAgain ? !!this.supplementary_info : this.formValidate();
      let aiMentorKey = `${this.cvDetail?.basic_info?.token}_aiMentor`

      // 再次提交信息
      // let againValueFlag = submitAgain && !this.supplementary_info
      if (!flag ) {
        this.$message.error('请完善所有信息')
        return
      }
      if(this.formSubmitLoading) return;
      this.formSubmitLoading = true;

      // 提交信息，进入解析中
      this.aiStep = 'parsing'
      this.missingQuestionList = []

      // 保存表单数据
      localStorage.setItem(aiMentorKey, JSON.stringify({
        jobInformation: this.jobInformation,
      }))

      let cvInfo = await this.getFormatCvInfo()
      let formData = {
        cv_token: cvInfo.cv_token,
        cv: cvInfo.cv,
        target_position: `最高学历：${this.jobInformation.highestEdu}；目标行业：${this.jobInformation.industry}；是否转行：${this.jobInformation.changeCareer}；职位名称：${this.jobInformation.jobType}；职位描述：${this.jobInformation.jd}`,
        job_search_status: this.jobInformation.job_search_status,
        user_concerns: this.jobInformation.user_concerns,
      }
      // 是否是再次提交信息
      if(submitAgain){
        formData.supplementary_info = this.supplementary_info
      }

      try {
        let res = await api.AI.aiMentorInputCheck(formData)
        // 标记请求完成
        this.formSubmitLoading = false;
        if(res.code === 1000){
          // let { missingItems } = res.data.result
          // 检查一下是否有ai给的问题
          // if(missingItems.length > 0){
          //   this.aiStep = 'parsingException'
          //   this.missingQuestionList = missingItems
          // }else{
          //   // ai没有给需要补充的问题，直接进行解析
          //   this.parseResume()
          // }
          // 去分析简历
          this.parseResume()
        }else{
          // 弹窗提示，没有次数了
          if(res.code === 120001){
            this.showNoCountModal = true
          }else{
            this.$message.error(res.message)
          }
          // 提交信息失败，退回填写表单 或者 补充信息
          this.aiStep = submitAgain ? 'parsingException' : 'form'
        }
      } catch (error) {
        console.error(error)
        this.$message.error('AI 开小差了～')
        // 提交信息失败，退回填写表单
        this.aiStep = submitAgain ? 'parsingException' : 'form'
        // 标记请求完成
        this.formSubmitLoading = false;
      }
    },

    // 开始计算ai思考时间
    startAiThinkTime(){
      this.thinkTime = 0
      clearInterval(this.thinkTimer)
      this.thinkTimer = setInterval(() => {
        this.thinkTime += 1
      }, 1000);
    },

    // 进行解析
    async parseResume(){
      // 进入简历评估
      this.aiStep = 'parseResume'
      // 开始计算ai思考时间
      this.startAiThinkTime()

      // 进入思考阶段
      this.aiThinkStep = 0
      setTimeout(() => {
        // 进入简历评估阶段
        this.aiThinkStep = 1
      }, 0.3 * 1000);


      // // 模拟完成
      // setTimeout(() => {
      //   this.jobAssessment()
      // }, 1 * 1000);

      // 整理简历信息
      let cvInfo = await this.getFormatCvInfo()
      let formData = {
        cv_token: cvInfo.cv_token,
        cv: cvInfo.cv,
        target_position: `最高学历：${this.jobInformation.highestEdu}；目标行业：${this.jobInformation.industry}；是否转行：${this.jobInformation.changeCareer}；职位名称：${this.jobInformation.jobType}；职位描述：${this.jobInformation.jd}`,
        job_search_status: this.jobInformation.job_search_status,
        user_concerns: this.jobInformation.user_concerns,
        supplementary_info: this.supplementary_info
      }
      this.cancelCvAssessmentConnection = await api.AI.aiMentorCvAssessment({
        data: formData,
        onMessage: (data={}) => {
          let { choices } = data
          if(choices && choices.length > 0){
            choices.forEach(item => {
              let { delta } = item
              if(delta && delta.content){
                // 先滚一次
                this.scrollAiMentorContent()
                this.aiThinkStep1Content += delta.content
                // 先渲染，再滚动
                setTimeout(() => {
                  this.scrollAiMentorContent()
                }, 0.2 * 1000);
              }
            })
          }
        },
		    onComplete: (data) => {
          console.log('进行解析 end=>', data)
          console.log('进行解析 end=> aiThinkStep1Content', this.aiThinkStep1Content)
          this.cancelCvAssessmentConnection = null;
          // 进入下一阶段
          this.jobAssessment()
        },
        onError: (error) => {
          console.log('进行解析 error=>', error)
          this.cancelCvAssessmentConnection = null;
          this.$message.error('AI 开小差了～')
        }
      })
    },

    // 职位评估
    async jobAssessment(){
      // 进入职位评估阶段
      this.aiThinkStep = 2

      // 整理简历信息
      let cvInfo = await this.getFormatCvInfo()
      let formData = {
        cv_token: cvInfo.cv_token,
        cv: cvInfo.cv,
        target_position: `最高学历：${this.jobInformation.highestEdu}；目标行业：${this.jobInformation.industry}；是否转行：${this.jobInformation.changeCareer}；职位名称：${this.jobInformation.jobType}；职位描述：${this.jobInformation.jd}`,
        job_search_status: this.jobInformation.job_search_status,
        user_concerns: this.jobInformation.user_concerns,
        supplementary_info: this.supplementary_info
      }
      this.cancelJobAssessmentConnection = await api.AI.aiMentorJobAssessment({
        data: formData,
        onMessage: (data={}) => {
          let { choices } = data
          if(choices && choices.length > 0){
            choices.forEach(item => {
              let { delta } = item
              // 先滚一次
              this.scrollAiMentorContent()

              if(delta && delta.content){
                this.aiThinkStep2Content += delta.content
              }
              // 先渲染，再滚动
              setTimeout(() => {
                this.scrollAiMentorContent()
              }, 0.2 * 1000);
            })
          }
        },
		    onComplete: (data) => {
          console.log('进行解析 end=>', data)
          console.log('进行解析 end=> aiThinkStep2Content', this.aiThinkStep2Content)
          this.cancelJobAssessmentConnection = null;

          // 进入下一阶段
          this.aiMentorOptimization()
        },
        onError: (error) => {
          console.log('进行解析 error=>', error)
          this.cancelJobAssessmentConnection = null;
          this.$message.error('AI 开小差了～')
        }
      })
    },

    // 简历优化
    async aiMentorOptimization(){
      // 进入简历优化阶段
      this.aiThinkStep = 3

      // 整理简历信息
      let cvInfo = await this.getFormatCvInfo()
      let formData = {
        cv_token: cvInfo.cv_token,
        cv: cvInfo.cv,
        cv_analysis: this.aiThinkStep1Content, //简历分析结果
        job_analysis: this.aiThinkStep2Content, //职位分析结果
      }

      try {
        let res = await api.AI.aiMentorOptimization(formData)
        if(res.code === 1000){
          // 生成报告
          this.aiMentorReport(formData)
        }else{
          this.$message.error('AI 开小差了～')
        }
      } catch (error) {
        console.log('进行解析 error=>', error)
        this.$message.error('AI 开小差了～')
      }

    },

    // 生成报告
    async aiMentorReport(formData){
      // 生成报告阶段
      this.aiThinkStep = 4
      try {
        let res = await api.AI.aiMentorReport(formData)
        if(res.code === 1000){
          // 展示用户鼓励
          this.createCvOptimization()
        }else{
          this.$message.error('AI 开小差了～')
        }
      } catch (error) {
        console.log('进行解析 error=>', error)
        this.$message.error('AI 开小差了～')
      }
    },

    // 创建ai导师简历
    async createCvOptimization(){
      try {
        let res = await api.AI.createCvOptimization({cv_token: this.cv_token})
        if(res.code === 1000){
          // 展示用户鼓励
          this.getAiThink5Content()
        }else{

          // 简单尝试一次
          try {
            let res = await api.AI.createCvOptimization({cv_token: this.cv_token})
            if(res.code === 1000){
              // 展示用户鼓励
              this.getAiThink5Content()
            }else{
              this.$message.error('AI 开小差了～')
              clearInterval(this.thinkTimer)
            }
          } catch (error) {
            console.log('进行解析 error=>', error)
            this.$message.error('AI 开小差了～')
            clearInterval(this.thinkTimer)
          }
        }
      } catch (error) {
        console.log('进行解析 error=>', error)
        this.$message.error('AI 开小差了～')
      }
    },

    // 用户鼓励
    async getAiThink5Content(isEnd){
      this.aiThinkStep = 5
      this.aiThinkStep5Content += `对着屏幕大叫3声：Passion！！！Passion！！！Passion！！！ <br/>`
      // 滚动到底部
      this.scrollAiMentorContent()
      setTimeout(() => {
        this.aiThinkStep5Content += `我一定能找到好工作！！！`
        setTimeout(() => {
          // 滚动到底部
          this.scrollAiMentorContent()
        }, 0.2 * 1000);
      }, isEnd ? 0 : 300);


      // 标记ai流程走完了
      this.aiThinkEnd()
    },

    // 思考结束
    aiThinkEnd(){
      this.aiThinkStep = 6
      clearInterval(this.thinkTimer)

      // 更新本地存储
      let aiMentorKey = `${this.cvDetail?.basic_info?.token}_aiMentor`
      localStorage.setItem(aiMentorKey, JSON.stringify({
        jobInformation: this.jobInformation,
        aiStep: this.aiStep,
        thinkTime: this.thinkTime,
        aiThinkStep1Content: this.aiThinkStep1Content,
        aiThinkStep2Content: this.aiThinkStep2Content,
      }))
    },

    // 滚动到底部
    scrollAiMentorContent(){
      let aiMentorContent = document.getElementById('aiMentorContent')
      if(aiMentorContent){
        aiMentorContent.scrollTop = aiMentorContent.scrollHeight
      }
    },

    // 查看报告
    viewReport(){
      let cvToken = this.cvDetail?.basic_info?.token
      window.open(`/ai/mentor/${cvToken}/report`)
    },

    // 没次数弹窗 - 编辑简历
    noCountNextAction(){
      this.showNoCountModal = false
    },
    // 没次数弹窗 - 关闭
    noCountKnowAction(){
      this.showNoCountModal = false
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
@import './index.scss';
</style>
<style lang="scss">
@import '@/assets/css/variable.scss';
.ai-mentor-select-popper {
  background-color: transparent !important;
  border-color: $select-border-color !important;
  background: linear-gradient(45deg, $select-bg-start-color 0%, $select-bg-middle-color 62%, $select-bg-end-color 100%);
  .el-scrollbar {
    .el-select-dropdown__wrap {
      .el-select-dropdown__list {
        .el-select-dropdown__item {
          color: $text-color;
          .es-highlighter {
            color: $theme-color;
          }
          &.hover,
          &:hover {
            background-color: $select-dropdown-item-hover;
          }
        }
      }
    }
  }
  .popper__arrow {
    display: none;
  }
}
</style>